import { render, staticRenderFns } from "./UploadArticles.vue?vue&type=template&id=78034e32&scoped=true&"
import script from "./UploadArticles.vue?vue&type=script&lang=js&"
export * from "./UploadArticles.vue?vue&type=script&lang=js&"
import style0 from "./UploadArticles.vue?vue&type=style&index=0&id=78034e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78034e32",
  null
  
)

export default component.exports